export function getNavPath(route) {
  return `/${route}`;
}
